module.exports = fox._r("fonts/ostrich-sans-bold.ttf", __webpack_public_path__ + "_/_/_/root/fonts/1S3bm0E.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/ostrich-sans-bold.ttf
// module id = 158
// module chunks = 4